import React, { ReactElement } from 'react';
import theme from './MultiList.module.scss';

type Props = {
    page: number;
    lastPage: number;
    setPage: (p: number) => void;
};

const MultiListPagination: React.FC<Props> = ({ page, lastPage, setPage }) => {
    const renderPaginationButtons = () => {
        const buttons: ReactElement[] = [];
        const firstButton = Math.max(0, page - 2);
        const lastButton = Math.min(lastPage, page + 3);
        for (let i = firstButton; i <= lastButton; i++) {
            if (i === page)
                buttons.push(
                    <button key={i} className={theme.active}>
                        {i + 1}
                    </button>
                );
            else
                buttons.push(
                    <button key={i} onClick={() => setPage(i)}>
                        {i + 1}
                    </button>
                );
        }
        return buttons;
    };

    return (
        <div className={theme.buttons}>
            <button onClick={() => setPage(0)}>{'<<'}</button>
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>
                {'<'}
            </button>
            {renderPaginationButtons()}
            <button disabled={page + 1 > lastPage} onClick={() => setPage(page + 1)}>
                {'>'}
            </button>
            <button onClick={() => setPage(lastPage)}>{'>>'}</button>
        </div>
    );
};

export default MultiListPagination;
